import { addComponentEventHandlers } from "../../../assets/javascripts/lib/component_event_handler";

addComponentEventHandlers(".ui-modal_dialog", (modalElement) => {
  // Close button handler
  const closeButton = modalElement.querySelector('[data-action="close-modal"]');
  if (closeButton) {
    closeButton.addEventListener("click", () => {
      modalElement.close();
      // Dispatch custom event for close action
      modalElement.dispatchEvent(
        new CustomEvent("modal:closed", {
          detail: { action: "close", modal: modalElement },
        }),
      );
    });
  }

  // Button click handlers
  const buttons = modalElement.querySelectorAll(".modal-footer button");
  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      // Get button data attributes or text content for identification
      const buttonId =
        button.getAttribute("data-button-id") || button.textContent.trim();

      // Dispatch custom event with button information
      modalElement.dispatchEvent(
        new CustomEvent("modal:buttonClicked", {
          detail: {
            buttonId: buttonId,
            button: button,
            modal: modalElement,
            originalEvent: event,
          },
        }),
      );

      // Close modal if button has close action (unless prevented by event listener)
      if (button.getAttribute("data-close-modal") !== "false") {
        modalElement.close();
      }
    });
  });

  // Backdrop click to close (optional feature)
  modalElement.addEventListener("click", (event) => {
    if (event.target === modalElement) {
      modalElement.close();
      modalElement.dispatchEvent(
        new CustomEvent("modal:closed", {
          detail: { action: "backdrop", modal: modalElement },
        }),
      );
    }
  });

  // ESC key handler
  modalElement.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      modalElement.close();
      modalElement.dispatchEvent(
        new CustomEvent("modal:closed", {
          detail: { action: "escape", modal: modalElement },
        }),
      );
    }
  });

  // ヘッダードラッガブル対応
  const dragHandleElement = modalElement.querySelector(".modal-drag-handle");
  if (dragHandleElement) {
    let dx, dy;
    dragHandleElement.addEventListener("pointerdown", (e) => {
      const r = modalElement.getBoundingClientRect();
      dx = e.clientX - (r.left + r.width / 2);
      dy = e.clientY - (r.top + r.height / 2);
      dragHandleElement.setPointerCapture(e.pointerId);
    });
    dragHandleElement.addEventListener("pointermove", (e) => {
      if (!dragHandleElement.hasPointerCapture(e.pointerId)) return;
      modalElement.style.setProperty("--x", `${e.clientX - dx}px`);
      modalElement.style.setProperty("--y", `${e.clientY - dy}px`);
    });
  }
});

// Global functions for opening modals
window.openModal = (modalId) => {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.showModal();
    modal.dispatchEvent(
      new CustomEvent("modal:opened", {
        detail: { modal: modal },
      }),
    );
  }
};

window.openModeless = (modalId) => {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.show();
    modal.dispatchEvent(
      new CustomEvent("modal:opened", {
        detail: { modal: modal },
      }),
    );
  }
};

window.closeModal = (modalId) => {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.close();
    modal.dispatchEvent(
      new CustomEvent("modal:closed", {
        detail: { action: "programmatic", modal: modal },
      }),
    );
  }
};
